
export default class Tab {
    path = '/';
    name = 'This is a Tab';
    type =  'file_list';
    icon = 'far fa-image';
    dismissable = true;

    constructor() {
    }
}